
import React, { useState, useEffect } from "react";
import "../../../src/custom.css";
import { addCoverImageToVideo, removeCoverImage } from '../../Redux/Api/fetch.api';
import toast from 'react-hot-toast';
import Loader from "../loader";
import { Modal } from 'antd';

export default function CoverImageModal({ isOpen, onClose, mediaId, existingCoverUrl, onSuccess }) {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setFile(null); // reset file
            setPreview(existingCoverUrl || null);
        }
    }, [isOpen, existingCoverUrl]);

    const handleFileChange = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;

        if (!selected.type.startsWith("image/")) {
            alert("Only image files are allowed.");
            return;
        }

        setFile(selected);
    };

    useEffect(() => {
        if (!file) {
            setPreview(existingCoverUrl || null);
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        setPreview(objectUrl);

        return () => {
            URL.revokeObjectURL(objectUrl);
        };
    }, [file]);

    useEffect(() => {
        if (!isOpen) return;

        const handleGlobalPaste = (e) => handlePaste(e);

        window.addEventListener("paste", handleGlobalPaste);

        return () => {
            window.removeEventListener("paste", handleGlobalPaste);
        };
    }, [isOpen]);

    const handleApply = async () => {
        if (!file) return;
        setLoading(true)
        try {
            const response = await addCoverImageToVideo(mediaId, file);
            if (response.data.success) {
                toast.success("Cover image uploaded successfully")

                const uploadedUrl =
                    (response && response.data && response.data.data && response.data.data.coverUrl) ||
                    (response && response.data && response.data.data && response.data.data.coverImageUrl) ||
                    (response && response.data && response.data.data && response.data.data.url) ||
                    (response && response.data && response.data.coverUrl) ||
                    (response && response.data && response.data.coverImageUrl) ||
                    (response && response.data && response.data.url) ||
                    null;

                if (uploadedUrl && typeof onSuccess === "function") {
                    onSuccess(mediaId, uploadedUrl);
                }
            }
            else {
                toast.error("Failed to upload cover image")
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to upload cover image")
        }
        finally {
            setLoading(false)
        }
        onClose();
    };

    const { confirm } = Modal;
    const handleRemoveCoverImage = (mediaId) => {

        confirm({
            title: "Are you sure to remove the Cover Image?",
            okText: "Yes",
            okType: 'danger',
            cancelText: "No",
            async onOk() {
                await handeCoverRemoval(mediaId)
            },
            onCancel() {

            },
        });
    }



    const handeCoverRemoval = async (mediaId) => {
        setLoading(true)
        try {
            const response = await removeCoverImage(mediaId);
            if (response.data.success) {
                toast.success("Cover image removed successfully")
            }
            else {
                toast.error("Failed to upload cover image")
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to upload cover image")
        }
        finally {
            setLoading(false)
        }
        onClose();
    };

    const handlePaste = (e) => {
        const items = e && e.clipboardData && e.clipboardData.items;
        if (!items) return;

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (item.type.startsWith("image/")) {
                const pastedFile = item.getAsFile();

                if (pastedFile) {
                    setFile(pastedFile);
                    toast.success("Image pasted successfully");
                }
            }
        }
    };

    return (
        <>
            {isOpen && (
                <div className="cover-modal">
                    {loading ? <Loader /> : ''}
                    <div className="cover-modal__overlay" onClick={onClose}></div>

                    <div className="cover-modal__box">
                        <div className="cover-modal__header">
                            <h3>Apply cover image</h3>
                            <button onClick={onClose}>×</button>
                        </div>

                        <p className="cover-modal__text">
                            One cover will be applied to corresponding video.
                        </p>

                        <label className="cover-modal__upload">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />

                            {preview ? (
                                <img
                                    src={preview}
                                    alt="Cover Preview"
                                    className="cover-modal__preview"
                                />
                            ) : (
                                <span>Click to Upload / Paste (Ctrl + V) cover image</span>
                            )}
                        </label>

                        <div className="cover-modal__footer">

                            {existingCoverUrl && !file && (
                                <button className="btn btn-secondary" onClick={() => handleRemoveCoverImage(mediaId)}>
                                    Remove Cover Image
                                </button>
                            )}
                            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                            <button className="btn btn-primary" onClick={handleApply} disabled={!file}>
                                Add Cover Image
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}